import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getCustomerCities,
  getCustomerCity,
  createCustomerCity,
  editCustomerCity,
  deleteCustomerCity,
  getAllCustomerCities,
  getTrashedCustomerCities,
  restoreCustomerCity,
} from "api/customerCityApi"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const CUSTOMER_CITY_QUERY_KEY = "customer-cities"
export const CUSTOMER_CITY_GROUP_QUERY_KEY = "customer-cities-group"

// -------------------- FETCH PAGINATED --------------------
export const useCustomerCities = (params = {}, enabled = true) => {
  return usePaginatedResource(
    CUSTOMER_CITY_QUERY_KEY,
    getCustomerCities,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useCustomerCity = (id, enabled = true) => {
  return useResourceItem(
    CUSTOMER_CITY_QUERY_KEY,
    getCustomerCity,
    id,
    enabled
  )
}

// -------------------- CREATE --------------------
export const useCreateCustomerCity = () => {
  return useCreateResource(createCustomerCity, CUSTOMER_CITY_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditCustomerCity = () => {
  return useEditResource(editCustomerCity, CUSTOMER_CITY_QUERY_KEY)
}

// -------------------- DELETE --------------------
export const useDeleteCustomerCity = () => {
  return useDeleteResource(deleteCustomerCity, CUSTOMER_CITY_QUERY_KEY)
}

// -------------------- ADDITIONAL --------------------

// Get all customer cities without pagination
export const useAllCustomerCities = (params = {}) => {
  return usePaginatedResource(
    CUSTOMER_CITY_QUERY_KEY,
    getAllCustomerCities,
    { ...params, all: true },
    true
  )
}

// Get trashed customer cities
export const useTrashedCustomerCities = (params = {}) => {
  return usePaginatedResource(
    CUSTOMER_CITY_QUERY_KEY,
    getTrashedCustomerCities,
    params,
    true
  )
}

// Restore a trashed customer city
export const useRestoreCustomerCity = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreCustomerCity,
    onSuccess: (res, { id }) => {
      const restoredItem = res?.data
      if (!restoredItem) return

      // Update paginated cache
      queryClient.setQueriesData([CUSTOMER_CITY_QUERY_KEY, "all"], old => {
        if (!old || !old.data || !Array.isArray(old.data.data)) return old
        const updated = structuredClone(old)
        updated.data.data = [restoredItem, ...updated.data.data]
        updated.data.total = (updated.data.total || 0) + 1
        return updated
      })

      // Update individual item cache
      queryClient.setQueryData([CUSTOMER_CITY_QUERY_KEY, id], restoredItem)
    },
  })
}
